/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyPharmacyGroupUpdatableTypename = "PharmacyPharmacyGroupUpdatable" as const;

/**
 *
 * @export
 * @interface PharmacyPharmacyGroupUpdatable
 */
export interface PharmacyPharmacyGroupUpdatable {
  /**
   *
   * @type {number}
   * @memberof PharmacyPharmacyGroupUpdatable
   */
  chainId?: number;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyGroupUpdatable
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyGroupUpdatable
   */
  name?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyPharmacyGroupUpdatable
   */
  readonly __typename?: string;
}

export function PharmacyPharmacyGroupUpdatableFromJSON(json: any): PharmacyPharmacyGroupUpdatable {
  return PharmacyPharmacyGroupUpdatableFromJSONTyped(json, false);
}

export function PharmacyPharmacyGroupUpdatableFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyPharmacyGroupUpdatable {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyPharmacyGroupUpdatableTypename,

    chainId: !exists(json, "chain_id") ? undefined : json["chain_id"],
    description: !exists(json, "description") ? undefined : json["description"],
    name: !exists(json, "name") ? undefined : json["name"],
  };
}

export function PharmacyPharmacyGroupUpdatableToJSON(object?: PharmacyPharmacyGroupUpdatable | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    chain_id: value.chainId,
    description: value.description,
    name: value.name,
  };
}
